<template>
  <section>
    <div class="title-outer" data-reveal-text>
      <!-- <div class="left-line"></div> -->
      <div>
        <div :class="!isPortrait?'main-title':'main-title-mob'">{{ title }}</div>
        <div :class="!isPortrait?'sub-title':'sub-title-mob'">{{ subtitle }}</div>
      </div>
    </div>
    <div class="my-weiper-container" :class="{ 'my-weiper-container-mob': !isPC }">
      <div class="swiper-container" :class="'swiper-container' + id" :style ="!isPC?'height:auto':''">
        <div class="swiper-wrapper">
          <div class="swiper-slide" :class="{ 'swiper-slide-mob': !isPC }" v-for="(item, index) in imgs" :key="index">
            <div v-if="!isPortrait" class="slide-flex">
              <div>
                <div v-if="item.type == 'video'" class="imgBox video-cover" @click="playVideo(item)">
                  <img :src="isPC ? item.imgPC : item.imgMob" :alt="item.title || ''">
                  <!-- <button
                    type="button"
                    class="play-button"
                    :aria-label="`播放${item.title || ''}视频`"
                    :code-stm="`event, PAGEURL, ${title}-${item.title} 点击封面视频/图片按钮`"
                    @click.stop="playVideo(item)"
                  >
                    <img src="../assets/images/play.png" alt="">
                  </button> -->
                </div>
                <div v-else>
                  <div class="imgBox">
                    <img class="swiper-lazy" :data-src="isPC ? item.imgPC : item.imgMob" alt="" :data-index="index">
                    <div class="swiper-lazy-preloader"></div>
                  </div>

                </div>
              </div>
              <div class="des">
                <div class="main">
                  <div class="title" v-html="item.title"></div>
                  <div class="text">{{ item.text }}</div>
                </div>
              </div>
            </div>
            <div v-else class="mob-s">
              <div v-if="item.type == 'video'" class="imgBox-mob video-cover" @click="playVideo(item)">
                <img :src="isPC ? item.imgPC : item.imgMob" :alt="item.title || ''">
                <!-- <button
                  type="button"
                  class="play-button"
                  :aria-label="`播放${item.title || ''}视频`"
                  :code-stm="`event, PAGEURL, ${title}-${item.title} 点击封面视频/图片按钮`"
                  @click.stop="playVideo(item)"
                >
                  <img src="../assets/images/play.png" alt="">
                </button> -->
              </div>
              <div v-else>
                <div class="imgBox-mob" :class="'imgBox-mob' + id">
                  <img class="swiper-lazy" :data-src="isPC ? item.imgPC : item.imgMob" alt="" :data-index="index">
                  <div class="swiper-lazy-preloader"></div>
                </div>
              </div>
              <div id="des" class="des-mob">
                <div class="main-mob">
                  <div class="title-mob" v-html="item.title"></div>
                  <div class="text-mob">{{ item.text }}</div>
                </div>
              </div>
              <!-- <div v-if="isPortrait" style="bottom: unset;" class="swiper-pagination" :class="'swiper-pagination' + id"></div> -->
            </div>
          </div>
        </div>
        <!-- <div class="swiper-pagination" :class="{ 'swiper-pagination-mob': !isPC }"></div> -->
        <div v-if="isPortrait" style="bottom: unset;top: calc(310 / 375 * 100vw);" class="swiper-pagination" :class="'swiper-pagination' + id"></div>
      </div>
      <div v-if="!isPortrait" class="swiper-pagination" :class="'swiper-pagination' + id"></div>
    </div>
    <my-video
      :isShow="isShowVideo"
      :videoSrc="videoSrc"
      :posterPc="videoPosterPc"
      :posterMob="videoPosterMob"
      :videoId="`videopicstext-video-${id}`"
      :maidiansuffix="title"
      @closeDialog="closeVideo"
    ></my-video>
  </section>
</template>
<script>
import Swiper from "swiper";
import { isPortraitFun, getUrlKey, isPc, maidian } from "@/utils/utils.js";
import MyVideo from '@/components/basic-video-zhijia.vue'
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      isShowVideo: false,
      videoSrc: '',
      videoPosterPc: '',
      videoPosterMob: ''
    }
  },
  components: {
    MyVideo
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    imgs: {
      type: Array,
      default: []
    },
    id: {
      type: String,
      default: ''
    },
  },
  mounted() {
    document.querySelector("#des")
    console.log(this.id)
    var that = this
    var swiper = new Swiper('.swiper-container' + this.id, {
      pagination: {
        el: '.swiper-pagination' + this.id,
        clickable: true,
      },
      autoplay: false,
      loop: false,
      speed: 500,
      preloadImages: false,
      watchSlidesVisibility: true,
      lazy: {
        loadOnTransitionStart: true,
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
    });
    swiper.init();
    swiper.on('slideChange', function () {
      maidian(that.title + '-' + that.imgs[this.realIndex].title)
    });
  },
  beforeDestroy() {
    this.closeVideo()
  },
  methods: {
    playVideo(item) {
      const videoSrc = this.isPC ? item.videoPc : item.videoMob
      if (!videoSrc) return

      this.videoSrc = videoSrc
      this.videoPosterPc = item.posterPc || ''
      this.videoPosterMob = item.posterMob || item.posterPc || ''
      this.isShowVideo = true
    },
    closeVideo() {
      this.isShowVideo = false
      this.videoSrc = ''
      this.videoPosterPc = ''
      this.videoPosterMob = ''
    }
  }
}
</script>
<style lang="scss" scoped>

.swiper-slide{
  background-color: #F7F8F8;
}
.mob-s{
  height: 60%;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: space-evenly;
}
.swiper-slide-mob{
  height: 99vw;
  background-color: #fff;
}
.title-outer {
  display: flex;
  

  //padding-top: calc(60/1920*100vw);
  //padding-bottom:1.5vw;
  padding-top: 2vw;
  padding-bottom: 5.5vw;

  @media (min-width: 768px) {
    padding: 6% 0 2% calc(150/1920*100vw) !important;
  }
  @media (max-width: 768px) {
    padding-left: calc(150/1920*100vw) !important;
  }
  // padding-left: calc(160/1920*100vw) !important;
  .left-line {
    width: 0.208333vw;
    height: 2.1875vw;
    background: #3A88BC;
    opacity: 1;
    // border: 4px solid #3A88BC;
    margin-right: 2.708333vw;
  }

  .main-title {

    font-size: calc(54 / 1920 * 100vw) !important;
    line-height: calc(66 / 1920 * 100vw) !important;
    // font-size: 2vw !important;
    // line-height: 3vw !important;
    color: #000 !important;
    font-family: zhonghei;
  }

  .main-title-mob {
    margin-top:calc(60 / 375 * 100vw);
    // font-weight: 400;
    // font-size: calc(28 / 375 * 100vw);
    // line-height: calc(30 / 375 * 100vw) !important;
    font-size: calc(56 / 750 * 100vw) !important;
    line-height: calc(76 / 750 * 100vw) !important;
    font-family: zhonghei;
    //padding-bottom: 1.458333vw;
    line-height: 2.1875vw;
    white-space: normal !important;
    max-width: calc(375/375*100vw);
    word-break: break-word !important;
  }

  .sub-title {
    // font-family: "heijian";
    font-size: calc(54 / 1920 * 100vw) !important;
    line-height: calc(66 / 1920 * 100vw) !important;
    font-family: zhonghei;
  }

  .sub-title-mob {
    // font-family: "heijian";
    // font-size: calc(28 / 375 * 100vw);
    // line-height: calc(30 / 375 * 100vw) !important;
    margin-top: 0;
    // font-weight: 400;
    font-size: calc(56 / 750 * 100vw) !important;
    line-height: calc(76 / 750 * 100vw) !important;
    font-family: zhonghei;
  }
}

.my-weiper-container {
  // width: 87.5vw;
  width: calc(1600 / 1920 * 100vw);
  margin: 0 auto;

  .swiper-container {
    width: 100%;
    height: 39.195419vw;
    background: rgba(5, 20, 31, 0.03);

    .imgBox {
      width: 57.8125vw;
      height: 39.21875vw;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .imgBox-mob{
      width: 100%;
      height: 65vw;
    }

    .video-cover {
      position: relative;
      cursor: pointer;

      > img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .play-button {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;
      width: calc(80 / 1920 * 100vw);
      height: calc(80 / 1920 * 100vw);
      padding: 0;
      border: 0;
      background: transparent;
      transform: translate(-50%, -50%);
      cursor: pointer;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    //ev5gtline-videopicstext-swiper
    .imgBox-mob11{
      width: 100%;
      height: 60vw;
    }

    .slide-flex {
      display: flex;
      justify-content: space-between;
    }

    .des {
      width: calc(630/1920*100vw);
      height: 36.4583vw;
      position: relative;

      .main {
        position: absolute;
        bottom: calc(0/1920*100vw);
        left: calc(30/1920*100vw);
      }
    }

    .title {
      font-size: 1.3vw;
      line-height: 2.2vw;
      color: #05141F;
      width: calc(450/1920*100vw);
      font-weight: 400;
    }

    .text {
      font-size: calc(16/1920*100vw);
      color: rgba(5, 20, 31, 0.6);
      line-height: calc(32/1920*100vw);
      width: calc(450/1920*100vw);
    }
  }
  .swiper-container-mob{
    height: calc(328 / 375 * 100vw);
  }
}

@media (max-width: 767px) {
  .my-weiper-container .swiper-container .play-button {
    width: calc(54 / 375 * 100vw);
    height: calc(54 / 375 * 100vw);
  }
}
.des-mob {
  // position: relative;
  // margin-top: 100px;
  .main-mob {
    text-align: center;
    // position: absolute;
     margin-top: 4vw;
    // left: calc(114/1920*100vw);
  }
  .title-mob{
    color: #000;

  }
  .text-mob {
    font-size: calc(8 / 375 * 100vw);
    line-height: 2;
    color: rgba(102, 102, 102, 1);
  }
}

.swiper-pagination {
  left: 50%;
  transform: translateX(-50%);
   margin-top:calc(36 / 1920 * 100vw) !important;
  width: 100%;
}
.my-weiper-container-mob{
  .swiper-pagination11 {
    top: calc(270 / 375 * 100vw) !important;
  }
}

::v-deep .swiper-pagination-bullet {
  // margin-right:calc(5/1920*100vw);
  width: calc(40 / 1920 * 100vw);
  height: 2px;
  margin-right: 0.5vw;
  background-color: #000;
  border-radius: 0;
  // opacity: 1;

}

::v-deep .swiper-pagination-bullet-active {
  width: calc(40 / 1920 * 100vw);
  opacity: 1;
}
@media (max-width: 767px) {
  ::v-deep .swiper-pagination-bullet {
  // margin-right:calc(5/1920*100vw);
  width: calc(48 / 750 * 100vw);
  height: 1px;
  margin-right: 1vw;
  background-color: #000;

}

::v-deep .swiper-pagination-bullet-active {
  width: calc(48 / 750 * 100vw);
  opacity: 1;
}
}

::v-deep .el-dialog__wrapper {

  .el-dialog {
    background: transparent;
  }
}
</style>
